// One spelling for every messenger and social network, everywhere a platform
// key is shown to a person (footer, chat buttons, "Write on …", admin).
// Brand casing matters: "WhatsApp", "VK", "LINE", "WeChat", "TikTok".
export const PLATFORM_LABELS = Object.freeze({
  whatsapp:  'WhatsApp',
  telegram:  'Telegram',
  line:      'LINE',
  wechat:    'WeChat',
  viber:     'Viber',
  messenger: 'Messenger',
  vk:        'VK',
  instagram: 'Instagram',
  facebook:  'Facebook',
  tiktok:    'TikTok',
  youtube:   'YouTube',
  pinterest: 'Pinterest',
  x:         'X',
  twitter:   'X',
  email:     'Email',
  phone:     'Phone',
  website:   'Website',
})

export function platformLabel(platform) {
  const key = String(platform || '').toLowerCase()
  if (PLATFORM_LABELS[key]) return PLATFORM_LABELS[key]
  return key ? key.charAt(0).toUpperCase() + key.slice(1) : ''
}
